import { toZonedTime, format } from "date-fns-tz";
import { PACIFIC_TIMEZONE } from "../constants";

export const convertUTCToPacific = (utcString: string): Date | null => {
  if (!utcString) return null;
  try {
    const utcDate = new Date(utcString);
    const pacificDate = toZonedTime(utcDate, PACIFIC_TIMEZONE);
    return new Date(pacificDate);
  } catch {
    return null;
  }
};

export const convertUTCToPacificDisplay = (utcString: string): string | null => {
  const pacificDate = convertUTCToPacific(utcString);
  if (!pacificDate) return null;
  try {
    return format(pacificDate, "MM/dd/yyyy", { timeZone: PACIFIC_TIMEZONE });
  } catch {
    return null;
  }
};

export const convertUTCToLocalDisplay = (utcString: string): string | null => {
  if (!utcString) return null;
  try {
    const utcDate = new Date(utcString);
    return format(utcDate, "MM/dd/yyyy");
  } catch {
    return null;
  }
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}; 